<template>
    <h1 v-zoezi-editable="{prop: 'countTo', html: false, multiline: false, number: true}">{{value}}</h1>
</template>

<script>
export default {
    name: 'zoezi-countup',

    zoezi: {
        title: 'Counter',
        icon: 'mdi-counter'
    },

    data: () => ({
        value: 0,
        mountedAt: null
    }),

    props: {
        countTo: {
            title: 'Value',
            type: Number,
            default: 100
        },
        delay: {
            title: 'Time (ms)',
            type: Number,
            default: 3000
        }
    },

    methods: {
        next() {
            let now = new Date();
            let elapsed = now.getTime() - this.mountedAt;
            let changePerMs = (Number(this.countTo) / Number(this.delay));
            this.value = Math.round(Math.min(this.countTo, Math.max(elapsed * changePerMs, this.value)));
            if (elapsed < this.delay) {
                setTimeout(this.next, 10);
            }
        }
    },

    mounted() {
        this.mountedAt = new Date();
        this.next();
    }
}
</script>
